import { useMutation } from '@tanstack/react-query'
import { deleteYoutubeAccount } from '../../service/user'

export const useDeleteYoutubeAccount = () => {
  return useMutation({
    mutationKey: ['delete-youtubeAccount'],
    mutationFn: deleteYoutubeAccount,
  })
}
